import React, { useState, useEffect, useMemo, useRef } from "react";
import "./Style/common.css";
import "./Style/header.css";
import "./Style/SearchActivities.css";
import "./Style/trophy_club.css";
import trophy_club_0 from "./Image/trophy_club/trophy_club_0.png";
import Loading from "../../Common/Loading";
import { useLocation } from "react-router-dom";
import SubHeader from "../../Common/SubHeader";
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import lessonIcon from "./Image/lessons_icon_lrg.png";
import gameIcon from "./Image/games_icon_lrg.png";
import testIcon from "./Image/tests_icon_lrg.png";


interface KeywordResult {
  KeyWord: string;
  DicFileName: string;
}

interface SearchResult {
  DicFileName: string;
  KeyWord: string;
  ShortDesc?: string;
  ChildShortDesc1?: string;
  ChildShortDesc2?: string;
  ChildShortDesc?: string;
  UnitCode: string;
  UnitName: string;
  ChapterCode: string;
  ChapterName: string;
  FileID: string;
  DICFileVersion?: string;
  Activity: string;
  Score: string;
  CssClassForSearchItems?: string;
  CssClassForActivity?: string;
  LessonDetails: string;
}

interface ActivityData extends SearchResult {}

interface ChapterData {
  DicFileName: string;
  KeyWord: string;
  UnitCode: string;
  UnitName: string;
  ChapterCode: string;
  ChapterName: string;
  ChildShortDesc1: string;
  ChildShortDesc2: string;
  activities: ActivityData[];
}

interface UnitData {
  DicFileName: string;
  KeyWord: string;
  ShortDesc: string;
  UnitCode: string;
  UnitName: string;
  chapters: ChapterData[];
}
const activityIcons: Record<string, string> = {
  activity_icon_lesson: lessonIcon,
  activity_icon_game: gameIcon,
  activity_icon_test: testIcon,
};


const SearchActivities: React.FC = () => {
  const location = useLocation();
  const CurrentAvatar = sessionStorage.getItem("CurrentAvatar");
  const [isLegendVisible, setIsLegendVisible] = useState(false);
  const [myPoints] = useState(0);
  const [overallWeeklyProgress] = useState(0);
  const [weekCount] = useState(0);
  const [userName, setUserName] = useState<string>("");
  const [purchases] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [keywordResults, setKeywordResults] = useState<KeywordResult[]>([]);
  const [activityResults, setActivityResults] = useState<SearchResult[]>([]);
  const [selectedKeyword, setSelectedKeyword] = useState<string | null>(null);
  const [isLoadingKeywords, setIsLoadingKeywords] = useState(false);
  const [isLoadingActivities, setIsLoadingActivities] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [currentSubject, setCurrentSubject] = useState<string>(
    sessionStorage.getItem("Subject") || "Mathematics"
  );
  const [isSubjectLoading, setIsSubjectLoading] = useState(false);
  const { exploredata } = location.state || {};
    const [showBackToTop, setShowBackToTop] = useState(false);
    const [showBackToBottom, setShowBackToBottom] = useState(true);
    const scrollContainerRef = useRef<HTMLElement | null>(null);
  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;



  useEffect(() => {
    const UserName = sessionStorage.getItem("FName");
    if (UserName !== null) {
      setUserName(UserName);
    }
    document.body.classList.add("StudyRoom-background");
    return () => {
      document.body.classList.remove("StudyRoom-background");
    };
  }, []);

  const SchoolCode = sessionStorage.getItem("SchoolCode");
  const FamilyCode = sessionStorage.getItem("FamilyCode");
  const Login = sessionStorage.getItem("Login");
  const Subject = sessionStorage.getItem("Subject");




   const findScrollContainer = (): HTMLElement => {
      const candidates: (HTMLElement | null)[] = [
        (document.scrollingElement as HTMLElement) || null,
        document.getElementById("contents_math"),
        document.getElementById("main_top_container"),
        document.getElementById("contents_english"),
        document.getElementById("contents_physics"),
        document.getElementById("contents_chemistry"),
        document.getElementById("contents_biology"),
        document.body,
        document.documentElement,
      ];

      for (const el of candidates) {
        if (!el) continue;
        try {
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
            return el;
          }
        } catch (e) {
        }
      }
      return (document.scrollingElement as HTMLElement) || document.documentElement;
    };

    // detect and store the scroll container so click handlers can scroll the same element
    scrollContainerRef.current = findScrollContainer();
    const registeredContainer = scrollContainerRef.current;

    const handleScroll = () => {
      const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
      const scrollTop = el.scrollTop;
      const innerH = el.clientHeight || window.innerHeight;
      const scrollHeight = el.scrollHeight;

      const scrollable = Math.max(0, scrollHeight - innerH);
      const TOL = 6;
      const atTop = scrollTop <= TOL;
      const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
      const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

      if (atTop) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
        return;
      }

      if (atBottom) {
        setShowBackToTop(true);
        setShowBackToBottom(false);
        return;
      }

      if (ratio < 0.5) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
      } else {
        setShowBackToTop(true);
        setShowBackToBottom(false);
      }
    };
     try {
      if (registeredContainer) {
        registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
      } else {
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
    } catch (e) {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    // run once to set initial state
    setTimeout(handleScroll, 0);





  useEffect(() => {
    const handleSubjectChange = () => {
      const storedSubject = sessionStorage.getItem("Subject") || "Mathematics";
      if (storedSubject !== currentSubject) {
        setIsSubjectLoading(true);
    
        setSearchText("");
        setKeywordResults([]);
        setActivityResults([]);
        setSelectedKeyword(null);
        setHasSearched(false);
        setIsLoadingKeywords(false);
        setIsLoadingActivities(false);
        
        setTimeout(() => {
          setCurrentSubject(storedSubject);
          setIsSubjectLoading(false);
        }, 1000);
      }
    };
    window.addEventListener("subjectChange", handleSubjectChange);
    return () => {
      window.removeEventListener("subjectChange", handleSubjectChange);
    };
  }, [currentSubject]);

  useEffect(() => {
    let debounceTimeout: NodeJS.Timeout;

    if (searchText.trim() === "") {
      setKeywordResults([]);
      setActivityResults([]);
      setSelectedKeyword(null);
      setHasSearched(false);
      setIsLoadingKeywords(false);
    } else {
      setHasSearched(true);

      debounceTimeout = setTimeout(() => {
        setIsLoadingKeywords(true);
        fetch(`${apiUrl}SearchKeywords/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            KeyWord: searchText.trim(),
            SchoolCode,
            FamilyCode,
            Login,
            Subject,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (Array.isArray(data)) {
              setKeywordResults(data);
            } else {
              console.error("Unexpected response:", data);
              setKeywordResults([]);
            }
            setSelectedKeyword(null);
            setActivityResults([]);
          })
          .catch((err) => {
            console.error("Keyword search failed:", err);
            setKeywordResults([]);
            setSelectedKeyword(null);
            setActivityResults([]);
          })
          .finally(() => setIsLoadingKeywords(false));
      }, 500);
    }

    return () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, [searchText, SchoolCode, FamilyCode, Login, Subject, apiUrl]);
  
  useEffect(() => {
    if (!selectedKeyword) {
      setActivityResults([]);
      return;
    }

    setIsLoadingActivities(true);
    fetch(`${apiUrl}GetKeywordActivities/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        KeyWord: selectedKeyword,
        SchoolCode,
        FamilyCode,
        Login,
        Subject,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setActivityResults(data);
        } else {
          console.error("Unexpected response:", data);
          setActivityResults([]);
        }
      })
      .catch((err) => {
        console.error("Activities fetch failed:", err);
        setActivityResults([]);
      })
      .finally(() => setIsLoadingActivities(false));
  }, [selectedKeyword, SchoolCode, FamilyCode, Login, Subject, apiUrl]);

  const getActivityLink = (activity: SearchResult): string => {
  const lessonDetails = activity.LessonDetails.split("^");
  const DicCode = lessonDetails[0]; 
  const lessoncode = lessonDetails[1]; 
  const ChildShortDesc = lessonDetails[2]; 
  const unitCode = lessonDetails[4] || activity.UnitCode;
  const chapterCode = lessonDetails[6] || activity.ChapterCode;
  const dicFileVersion = activity.DICFileVersion || "";
  const activitytype =
    activity.CssClassForActivity === "activity_icon_game"
      ? "G"
      : activity.CssClassForActivity === "activity_icon_test"
      ? "T"
      : "L";

  const calledFrom =
    "&calledFrom=" + encodeURIComponent("/STUDENT/MSR/SearchActivities");

  if (activitytype === "G") {
    return `/STUDENT/Tutorials/Game?LsnTestCode=${lessoncode + "_E"}${calledFrom}`;
  }
  if (activitytype === "T") {
    return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&LsnTestCode=${lessoncode}&name=${ChildShortDesc}${calledFrom}`;
  }
  // Default: lesson/tutorial
  return `/STUDENT/Tutorials/Tutorial?id=${encodeURIComponent(
    lessoncode + "_E"
  )}&diccode=${encodeURIComponent(DicCode)}&name=${encodeURIComponent(
    ChildShortDesc
  )}&unitCode=${encodeURIComponent(unitCode)}&chapterCode=${encodeURIComponent(
    chapterCode
  )}&dicFileVersion=${encodeURIComponent(dicFileVersion)}${calledFrom}`;
};


  const handleTrophyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLegendVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = () => setIsLegendVisible(false);
    if (isLegendVisible) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isLegendVisible]);

  const groupedUnitsData = useMemo((): UnitData[] => {
    if (!selectedKeyword || activityResults.length === 0) return [];

    const unitsMap = new Map<string, UnitData>();

    activityResults.forEach((item) => {
      const unitKey = `${item.DicFileName}_${item.UnitCode}`;

      if (!unitsMap.has(unitKey)) {
        unitsMap.set(unitKey, {
          DicFileName: item.DicFileName,
          KeyWord: item.KeyWord,
          ShortDesc: item.ShortDesc || "",
          UnitCode: item.UnitCode,
          UnitName: item.UnitName,
          chapters: [],
        });
      }

      const unit = unitsMap.get(unitKey)!;
      const chapterKey = `${item.ChapterCode}`;

      let chapter = unit.chapters.find((c) => c.ChapterCode === chapterKey);
      if (!chapter) {
        chapter = {
          DicFileName: item.DicFileName,
          KeyWord: item.KeyWord,
          UnitCode: item.UnitCode,
          UnitName: item.UnitName,
          ChapterCode: item.ChapterCode,
          ChapterName: item.ChapterName,
          ChildShortDesc1: item.ChildShortDesc1 || "",
          ChildShortDesc2: item.ChildShortDesc2 || "",
          activities: [],
        };
        unit.chapters.push(chapter);
      }

      chapter.activities.push(item);
    });

    return Array.from(unitsMap.values());
  }, [activityResults, selectedKeyword]);

  const handleSearchClick = (keyword: string) => {
    setSelectedKeyword(keyword);
  };

const handleActivityClick = (activity: SearchResult) => {
  const lessonDetails = activity.LessonDetails.split("^");
  const dicCode = lessonDetails[0] || activity.DicFileName;
  const lessonCode = lessonDetails[1] || activity.FileID;
  const unitCode = lessonDetails[4] || activity.UnitCode;
  const unitName = lessonDetails[5] || activity.UnitName || "";
  const chapterCode = lessonDetails[6] || activity.ChapterCode;
  const chapterName = lessonDetails[7] || activity.ChapterName || "";

  sessionStorage.setItem("SelectedDICFile", dicCode);
  sessionStorage.setItem("LsnTestCode", lessonCode);
  sessionStorage.setItem("UnitCode", unitCode);
  sessionStorage.setItem("UnitName", unitName);
  sessionStorage.setItem("ChapterCode", chapterCode);
  sessionStorage.setItem("ChapterName", chapterName);
  sessionStorage.setItem("DICFileVersion", activity.DICFileVersion || "");

  const link = getActivityLink(activity);
  window.location.href = link; // Navigate to the target page
};


  return (
    <form id="form1">
      {isSubjectLoading && <Loading />}
      <>
        <Header />
                       <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',

       
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>
        <Section />
        <SubHeader>
          <div id="tool_bar">
            <div id="tool_bar_container" className="section_div">
              <div className="back_sml_btn">
                <a id="linkbtnBack" href="/STUDENT/MSR/ExploreActivities">
                  Back
                </a>
              </div>
            </div>
          </div>

          <div id="contents_math" className="contents section_container">
            <div id="search_page_container" className="section_div">
              <div id="search_page_left_div">
                <p className="search_page_title">Search</p>

                <input
                  id="txtSearchActivityText"
                  name="search_text"
                  className="txtSearchActivityTextT"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setSelectedKeyword(null);
                  }}
                  placeholder=""
                />
                <p className="search_page_subtitle">Search results</p>

                {hasSearched && (
                  <div
                    id="search_left_results_container"
                    className="search_left_results"
                  >
                    {isLoadingKeywords && <Loading />}

                    {/* {!isLoadingKeywords &&
                      searchText.trim().length > 0 &&
                      keywordResults.length === 0 && (
                        <p>No results found for "{searchText}"</p>
                      )} */}

                    {!isLoadingKeywords &&
                      keywordResults.map((item, index) => (
                        <button
                          key={`keyword-${index}`}
                          type="button"
                          onClick={() => handleSearchClick(item.KeyWord)}
                          style={{
                            border: "none",
                            background: "none",
                            width: "100%",
                            textAlign: "left",
                            padding: 0,
                            cursor: "pointer",
                            paddingLeft: "10px",
                          }}
                        >
                          <div
                            id={`divSelectedSearchListItem${index + 1}`}
                            className="search-list"
                            style={{
                              backgroundColor:
                                selectedKeyword === item.KeyWord
                                  ? "#c6ffc6"
                                  : "transparent",
                              padding: "7px",
                              fontSize: "12px",
                              lineHeight: "1",
                            }}
                          >
                            <p
                              className="search-list"
                              style={{
                                margin: 0,
                                fontSize: "12px",
                              }}
                            >
                              {item.KeyWord}
                            </p>
                          </div>
                        </button>
                      ))}
                  </div>
                )}
              </div>

              <div
                id="search_page_right_div"
                style={{ display: selectedKeyword ? "block" : "none" }}
              >
                <p id="pActivitySearchTitle" className="search_page_subtitle">
                  Activities found for "{selectedKeyword}":
                </p>

                {isLoadingActivities && <Loading />}

                {!isLoadingActivities &&
                  groupedUnitsData.map((unit, unitIndex) => (
                    <div key={`unit-${unitIndex}`}>
                      <input type="hidden" value={unit.DicFileName} />
                      <input type="hidden" value={unit.KeyWord} />

                      <div className="search_result_year">
                        <p>{unit.ShortDesc}</p>
                      </div>

                      {unit.chapters.map((chapter, chapterIndex) => (
                        <div key={`chapter-${unitIndex}-${chapterIndex}`}>
                          <input type="hidden" value={chapter.DicFileName} />
                          <input type="hidden" value={chapter.KeyWord} />
                          <input type="hidden" value={chapter.UnitCode} />
                          <input type="hidden" value={chapter.UnitName} />
                          <input type="hidden" value={chapter.ChapterCode} />
                          <input type="hidden" value={chapter.ChapterName} />

                          <div className="search_result_unit">
                            <p>{chapter.ChildShortDesc1}</p>
                          </div>
                          <div className="search_result_chapter">
                            <p>{chapter.ChildShortDesc2}</p>
                          </div>

                          {chapter.activities.map((activity, activityIndex) => (
                            <button
                              key={`activity-${unitIndex}-${chapterIndex}-${activityIndex}`}
                              type="button"
                         onClick={() => handleActivityClick(activity)}
                              className="search_activity"
                              style={{
                                border: "none",
                                background: "none",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                padding: 0,
                              }}
                            >
                              <div className="search_last_score_percentage">
                                <p>{activity.Score}</p>
                              </div>
                        <div
  style={{
    marginTop: "10px",
    height: "24px",
    width: "38px",
    backgroundImage: `url(${activityIcons[activity.CssClassForActivity || ""] || ""})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "inline-block",
  }}
></div>

                              <div className="activity_name">
                                <p>{activity.Activity}</p>
                              </div>
                            </button>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))}
              </div>

              <div className="subject_middle_gap"></div>
              <div className="subject_middle_gap"></div>
            </div>
          </div>
        </SubHeader>
      </>
      <div id="contents_english" className="contents section_container"></div>
      <div id="contents_physics" className="contents section_container"></div>
      <div id="contents_chemistry" className="contents section_container"></div>
      <div id="contents_biology" className="contents section_container"></div>

      {/* Hidden fields */}
      <input
        type="hidden"
        id="hidOverAllWeeklyProgress"
        value={overallWeeklyProgress}
      />
      <input type="hidden" id="hidSelectedSearchListItem" value="" />
      <input type="hidden" id="hidSchoolCode" value="" />
      <input type="hidden" id="hidFamilyCode" value="" />
    </form>
  );
};

export default SearchActivities;